import z from "zod";

import { SIZES } from "@frontend/styles/constants";

// Absent -> false (e.g. `checked`, `disabled`, `required`).
const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

export const checkboxDataSchema = z.object({
  size: z.enum(SIZES).optional(),
  label: z.string().optional(),
  name: z.string().optional(),
  value: z.string().optional(),
  inputId: z
    .string()
    .optional()
    .describe(
      "Id forwarded to the hidden <input> so an external <label for> can " +
        "toggle the checkbox — not `id`, which stays on the host element " +
        "for handle lookups and would win the label association otherwise.",
    ),
  checked: booleanAttribute,
  disabled: booleanAttribute,
  required: booleanAttribute,
});

export type CheckboxDataProps = z.infer<typeof checkboxDataSchema>;
